// extracted by mini-css-extract-plugin
export default {"modul_in_development":"ItProjects_modul_in_development__8sBOG"};